import {
    AddMarkerFailureActionType,
    AddMarkerSuccessActionType,
    DeleteMarkerSuccessActionType,
    InitMarkersActionType,
    MarkersActionTypes,
    UpdateMarkerSuccessActionType,
} from "./types";
import { Handler } from "./../types/store-types";

import { FieldTypes } from "../fields/types";

const initMarkers: Handler<{}, InitMarkersActionType> = (state, { payload: { list } }) => {
    const mapFields = list
        .map(field => {
            if (field.type === FieldTypes.MAP) return { id: field._id, markers: field.markers };
            return undefined;
        })
        .filter(field => field);

    if (mapFields.length) {
        const markersState = mapFields.reduce((accField, mapField) => {
            if (mapField?.id && mapField?.markers) {
                return {
                    ...accField,
                    [mapField.id]: mapField.markers.reduce((accMarker, marker) => {
                        return {
                            ...accMarker,
                            [marker._id]: {
                                location: marker.location,
                                description: marker.description,
                                geometry: marker.geometry,
                            },
                        };
                    }, {}),
                };
            } else {
                return { ...accField };
            }
        }, {});

        return { ...state, ...markersState };
    }
    return state;
};

const addMarkerSuccess: Handler<{}, AddMarkerSuccessActionType> = (state, { payload: { fieldId, markers } }) => {
    return {
        ...state,
        ...{
            [fieldId]: markers.reduce((accMarker, marker) => {
                return {
                    ...accMarker,
                    [marker._id]: {
                        location: marker.location,
                        description: marker.description,
                        geometry: marker.geometry,
                    },
                };
            }, {}),
        },
    };
};

const addMarkerFailure: Handler<{}, AddMarkerFailureActionType> = state => {
    return state;
};

const deleteMarkerSuccess: Handler<{}, DeleteMarkerSuccessActionType> = (state, { payload: { fieldId, markers } }) => {
    return {
        ...state,
        ...{
            [fieldId]: markers.reduce((accMarker, marker) => {
                return {
                    ...accMarker,
                    [marker._id]: {
                        location: marker.location,
                        description: marker.description,
                        geometry: marker.geometry,
                    },
                };
            }, {}),
        },
    };
};

const deleteMarkerFailure: Handler<{}, AddMarkerFailureActionType> = state => {
    return state;
};

const updateMarkerSuccess: Handler<{}, UpdateMarkerSuccessActionType> = (state, { payload: { fieldId, markers } }) => {
    return {
        ...state,
        ...{
            [fieldId]: markers.reduce((accMarker, marker) => {
                return {
                    ...accMarker,
                    [marker._id]: {
                        location: marker.location,
                        description: marker.description,
                        geometry: marker.geometry,
                    },
                };
            }, {}),
        },
    };
};

const updateMarkerFailure: Handler<{}, AddMarkerFailureActionType> = state => {
    return state;
};

export const handlersMarkers = {
    [MarkersActionTypes.INIT_MARKERS]: initMarkers,

    [MarkersActionTypes.ADD_MARKER_SUCCESS]: addMarkerSuccess,
    [MarkersActionTypes.ADD_MARKER_FAILURE]: addMarkerFailure,

    [MarkersActionTypes.DELETE_MARKER_SUCCESS]: deleteMarkerSuccess,
    [MarkersActionTypes.DELETE_MARKER_FAILURE]: deleteMarkerFailure,

    [MarkersActionTypes.UPDATE_MARKER_SUCCESS]: updateMarkerSuccess,
    [MarkersActionTypes.UPDATE_MARKER_FAILURE]: updateMarkerFailure,
};
